import { useEffect, useState } from "react";
import { Heading, List, ListItem, Stack, Text } from "@chakra-ui/react";
import { useRouter } from "next/router";

import CustomWrapper from "components/Chakra/CustomWrapper";
import MetaHead from "components/MetaHead";
import Card from "./Card";
import { useTracking } from "contexts/Tracking";
import { usePostV1LeadCreateLeadFromOfferMutation } from "@ud/api/phpApi/__generated__/authApi.generated";
import CustomLink from "components/Chakra/CustomLink";
import IconCheckGreen from "components/Chakra/Icons/CheckGreen";
import IconCrossCircleRed from "components/Chakra/Icons/CrossCircleRed";
import Checkbox from "components/Chakra/Checkbox";

const informationsWithIdealniNajemce: Array<string> = [
  "Zajištění nájemníka",
  "Kompletní péče o pronájem",
  "Nájemné vždy a včas",
  "Garance stavu bytu",
];
const informationsWithoutIdealniNajemce: Array<{
  isInclude: boolean;
  text: string;
}> = [
  { isInclude: true, text: "Inzerce" },
  { isInclude: false, text: "Pronajímání s riziky" },
  { isInclude: false, text: "Řešení všeho na vlastní pěst" },
];
const InsertOfferSingpost: React.FC = () => {
  const {
    query: { offerId },
  } = useRouter();
  const [isInterestInService, setIsCheck] = useState(false);
  const { trackEvent } = useTracking();
  const [createLeadFromOffer] = usePostV1LeadCreateLeadFromOfferMutation();

  useEffect(
    () =>
      trackEvent({
        "dl.eCat": "offer_create",
        "dl.eAct": "page.loaded",
        "dl.eLab": "Idealni najemce",
      }),
    [],
  );

  const createLead = async () => {
    if (offerId) {
      const res = await createLeadFromOffer({
        body: { offerId: parseInt(offerId.toString()) },
      });
      if ("data" in res) {
        trackEvent({
          "dl.eCat": "offer_create",
          "dl.eAct": "lead",
          "dl.eLab": "Idealni najemce",
        });
      }
    }
  };

  return (
    <>
      <MetaHead
        title="Inzerce - rozcestník"
        description="Inzerce na vlastní pěst nebo pronájem bez starostí?"
        canonicalUrl="https://www.ulovdomov.cz/vlozeni-inzeratu/rozcestnik"
      />
      <CustomWrapper>
        <Heading as="h1" variant="h1" pt="80px" maxW="699px" m="0 auto">
          Inzerce na vlastní pěst nebo pronájem bez starostí?
        </Heading>
        <Stack
          direction={{ base: "column", md: "row" }}
          spacing={{ base: "40px", md: "20px" }}
          justifyContent="center"
          mt={{ base: "40px", md: "60px" }}
          mb={{ base: "40px", md: "80px" }}
        >
          <Card
            title="Pronájem se službou Ideální nájemce"
            isIdealniNajemce
            price="zdarma"
            button={
              <CustomLink
                dataTest="idealninajemce.offer"
                to="/moje-inzeraty/in-inzerat"
                variant="button"
                onClick={() => {
                  createLead();
                  trackEvent({
                    "dl.eCat": "offer_create",
                    "dl.eAct": "bttn.clicked",
                    "dl.eLab": "Idealni najemce",
                  });
                }}
              >
                Mám zájem – ozvěte se mi
              </CustomLink>
            }
            descriptions={
              <List spacing="16px">
                {informationsWithIdealniNajemce.map((text, index) => (
                  <ListItem key={index}>
                    <IconCheckGreen />
                    <Text display="inline-block" ml="16px">
                      {text}
                    </Text>
                  </ListItem>
                ))}
              </List>
            }
          />
          <Card
            title="Pronájem na vlastní pěst"
            price="od 49 Kč"
            button={
              <CustomLink
                dataTest="ulovdomov.offer"
                variant="button_outline"
                to="/cenik/[offerId]"
                onClick={() => {
                  trackEvent({
                    "dl.eCat": "offer_create",
                    "dl.eAct": "bttn.clicked",
                    "dl.eLab": "Inzerce",
                  });
                  if (isInterestInService) {
                    createLead();
                  }
                }}
                routeProps={{ offerId: offerId?.toString() }}
              >
                Pokračovat v inzerci
              </CustomLink>
            }
            descriptions={
              <>
                <List spacing="16px">
                  {informationsWithoutIdealniNajemce.map(
                    ({ isInclude, text }, index) => (
                      <ListItem key={index}>
                        {isInclude ? (
                          <IconCheckGreen />
                        ) : (
                          <IconCrossCircleRed />
                        )}
                        <Text display="inline-block" ml="16px">
                          {text}
                        </Text>
                      </ListItem>
                    ),
                  )}
                </List>
                <Checkbox
                  isChecked={isInterestInService}
                  onChange={() => setIsCheck(!isInterestInService)}
                  label="Mám i zájem o službu Ideální nájemce"
                />
              </>
            }
          />
        </Stack>
      </CustomWrapper>
    </>
  );
};

export default InsertOfferSingpost;
